import Names from '../../data/names.yaml';

export default class Roster {
  constructor() {
    this.names = [];
    this.fill();
  }

  pluck() {
    if (this.names.length <= 0) {
      this.fill();
    }
    console.log("Name plucked. " + (this.names.length - 1) + " names in roster.");
    return this.names.pop();
  }

  fill() {
    this.names = [];
    this.names.push(...Names);
    this.shuffle();

    console.log("Roster filled. " + this.names.length + " names in roster.");
  }

  shuffle() {
    for (let i = this.names.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [this.names[i], this.names[j]] = [this.names[j], this.names[i]];
    }
  }
}
